module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAwCAYAAADgvwGgAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFJJREFUeNrs2MENACAIBEFiBZRGCXRkyehLK/BIzG7Ce5J7Yva4qop90wRQ1s1VUAIBAQEBAQEBdUOhgIZ1JJsREBAQEBAQEPBj0BXgeQEuAQYAoAKibaqhq2kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/img/faunhui1.png
// module id = jLP5
// module chunks = 92